import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Clock, ArrowRight, BookOpen, TrendingUp,
  Eye, Heart, Share2
} from "lucide-react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/subscreens/customer/home/blogs/Blog.css";
import BlogCard from "../../../../components/customer/home/blogcard/BlogCard";


export default function WorkHubBlog() {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(0);
  const [hoveredCard, setHoveredCard] = useState(null);

  const timerRef = useRef(null);

  const [visibleCount, setVisibleCount] = useState(3);
  // tiptap
  const cleanDescription = (html) => {
  if (!html) return "";

  const txt = document.createElement("textarea");
  txt.innerHTML = html;

  const decoded = txt.value;

  return decoded.replace(/<[^>]*>/g, "").trim();
};

const getExcerpt = (html, maxLength = 120) => {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(html, "text/html");
  const text = doc.body.textContent || "";

  return text.length > maxLength
    ? text.substring(0, maxLength) + "..."
    : text;
};
  /* ── Fetch Blogs API ── */
  useEffect(() => {
    axios.get(`${baseUrl}/user/viewblogs`)
      .then((res) => {
        if (res.data.success) {
          setBlogs(res.data.blogs);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [baseUrl]);

  /* ── Responsive cards ── */
  useEffect(() => {
    const updateVisible = () => {
      if (window.innerWidth < 600) setVisibleCount(1);
      else if (window.innerWidth < 900) setVisibleCount(2);
      else setVisibleCount(3);
    };

    updateVisible();
    window.addEventListener("resize", updateVisible);
    return () => window.removeEventListener("resize", updateVisible);
  }, []);

  const maxIndex = Math.max(0, blogs.length - visibleCount);

  const next = useCallback(() => {
    setCurrent((p) => (p >= maxIndex ? 0 : p + 1));
  }, [maxIndex]);

  const prev = useCallback(() => {
    setCurrent((p) => (p <= 0 ? maxIndex : p - 1));
  }, [maxIndex]);

  useEffect(() => {
    if (isHovered) return;
    timerRef.current = setInterval(next, 4000);
    return () => clearInterval(timerRef.current);
  }, [isHovered, next]);

  const handleReadMore = (blog) => {
    navigate(`/blogs/${blog.url_slug}`);
  };

  const cardWidthPct = 100 / visibleCount;
  const translateX = -(current * cardWidthPct);

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading blogs...</p>;
  }

  return (
    <section className="whb-section">

      <div className="whb-header">
        <div className="whb-badge">
          <BookOpen size={16} />
          <span>INSIGHTS & TIPS</span>
        </div>

        <h2 className="whb-title">Latest from Our Blog</h2>
        <p className="whb-subtitle">
          Expert home tips and guides
        </p>
      </div>

      {/* Slider */}
      <div
        className="whb-slider-wrap"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className="whb-track"
          style={{
            transform: `translateX(${translateX}%)`,
            transition: "transform 0.6s ease"
          }}
        >
        {blogs.map((blog) => (
<BlogCard
  key={blog.id}
  blog={{
    ...blog,
    description: cleanDescription(blog.description)
  }}
  baseUrlForFile={baseUrlForFile}
  onReadMore={handleReadMore}
/>
))}
        </div>

      <button className="whb-arrow whb-arrow--prev" onClick={prev} aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button className="whb-arrow whb-arrow--next" onClick={next} aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
      </div>

      {/* Dots */}
      <div className="whb-dots">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <button
            key={i}
            className={`whb-dot${i === current ? " whb-dot--active" : ""}`}
            onClick={() => setCurrent(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      {/* View All */}
      <div className="whb-view-all-wrap">
        <button className="whb-view-all" onClick={() => navigate('/blogs')}>
          <span>View All Articles</span>
          <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
}